import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Submitted from "assets/icons/Submitted.svg";
import { Title } from "../constant/Home/VendorOnboarding";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const PostSignupThankYouPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    // Clear any existing auth to truly send user to login
    const cookies = new Cookies();
    cookies.remove("token", { path: "/" });
    localStorage.removeItem("userData");
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <Box className="pt-[84px] flex justify-center px-4">
      <Box
        sx={{
          maxWidth: "840px",
          borderRadius: "16px",
          paddingY: { md: 3, xs: 2 },
          paddingX: { md: 4, xs: 2 },
          gap: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid #ECECEC",
          width: "100%",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            className="md:h-[144px] md:w-[144px] h-[100px] w-[100px] mb-[32px]"
            src={Submitted}
            alt="Submitted"
          />
          <Typography
            variant="h1"
            sx={{ color: "#242424", lineHeight: "42px", textAlign: "center" }}
          >
            Thank You for Completing Your Application
          </Typography>
          <Typography
            sx={{
              color: "#595959",
              fontSize: { md: "20px", xs: "16px" },
              textAlign: "center",
              lineHeight: "30px",
            }}
          >
            Thanks for signing up and we will be in touch when we go live
          </Typography>
        </Box>

        <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleContinue}
            sx={{
              backgroundColor: "#3CAB5C",
              padding: "12px 16px",
              fontSize: "16px",
              maxHeight: "48px",
              "&:hover": { backgroundColor: "#3CAB5C" },
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PostSignupThankYouPage;

